import '../../common/polyfills'
import get from 'lodash/get'
import { tag } from '@pcln/measure'
import {
  getFireFlyParams,
  isql2bot,
} from '../listings-client/util/fireFly/fireFlyData'
import { getListingsTestState } from '../utils'

import { airSearch } from '../listings-client/services/airSearch'

//  TAG Initial Page Load Data
if (typeof window !== 'undefined') {
  const preloadedState = get(window, '__PRELOADED_STATE__', {})
  const PCLN_BOOTSTRAP_DATA = get(
    window,
    '__PRELOADED_STATE__.pclnBootstrapData'
  )

  if (PCLN_BOOTSTRAP_DATA) {
    const SETI = preloadedState.seti || {}
    const {
      whiteLabelFireflyEnabled,
      tripType,
      referralId,
      userAgent,
      disableql2,
    } = getFireFlyParams({ pclnBootstrapData: PCLN_BOOTSTRAP_DATA })

    const isValid =
      whiteLabelFireflyEnabled &&
      !isql2bot({ referralId, userAgent, disableql2 })

    const isFireFlyOWEligible = tripType === 'OW' && isValid
    const isFireFlyRTEligible = tripType === 'RT' && isValid

    if (isFireFlyOWEligible || isFireFlyRTEligible) {
      tag(
        'AIR_SEARCH_FIREFLY_ALL_TRAFFIC',
        getListingsTestState({
          PCLN_BOOTSTRAP_DATA,
          setiName: 'AIR_SEARCH_FIREFLY_ALL_TRAFFIC',
        }),
        { newrelic: true }
      )
    }
    // Tag the Trip Type
    tag('ITIN_TYPE', tripType, { newrelic: true })

    // Kick off the AirSearch call on Page Load
    window.__AIR_SEARCH_PROMISE__ = airSearch({
      pclnBootstrapData: PCLN_BOOTSTRAP_DATA,
      SETI,
    })
  }
}
